import React from 'react';
import useFetchData from '../../../../hooks/useFetchData';
import GeneralComponentErrorShield from '../../../general/GeneralComponentErrorShield';
import WinnersAndLosersChart from './subComponents/WinnersAndLosersChart.component';
import {
  activeDateRangeEndSelector,
  activeDateRangeStartSelector,
} from '../../../../redux/pages/selectors';
import { useSelector } from 'react-redux';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';

const AssetAndCurrency: React.FC<FundInfoComponentProps> = ({ fundId }) => {
  const fromDate = useSelector(activeDateRangeStartSelector);
  const toDate = useSelector(activeDateRangeEndSelector);

  const PerformanceAttributionData = useFetchData({
    url: `/performance_attribution/${fundId}/${fromDate}/${toDate}`,
    keyName: `performance_attribution_${fundId}_${fromDate}_${toDate}`,
    makeFetch:
      fundId !== undefined &&
      fromDate !== null &&
      fromDate !== '' &&
      toDate !== null &&
      toDate !== '',
  });

  return (
    <GeneralComponentErrorShield
      dataObjects={[PerformanceAttributionData]}
      customLoadingMessages={[
        'Loading Performance Attribution Data',
        `${fromDate} to ${toDate}`,
        'Just a few more seconds...',
      ]}
      customErrorMessage="No Data Available."
    >
      <WinnersAndLosersChart data={PerformanceAttributionData} type={'asset'} />
      <WinnersAndLosersChart
        data={PerformanceAttributionData}
        type={'currency'}
      />
    </GeneralComponentErrorShield>
  );
};

export default AssetAndCurrency;
